import { TabProps } from '@Components/tab/view';

export const tabs: TabProps[] = [
    {
        key: 'club',
        name: 'クラブ情報',
        icon: 'hole',
    },
    {
        key: 'access',
        name: 'アクセス',
        icon: 'car',
    },
    {
        key: 'buying',
        name: '購入について',
        icon: 'cart',
    },
    {
        key: 'selling',
        name: '売却について',
        icon: 'update',
    },
    {
        key: 'news',
        name: 'お知らせ',
        icon: 'info',
    },
];
